import { FunctionalComponent, h } from '@stencil/core';
import { EventDate as EventDateType } from './DateService';

type Props = {
  date: EventDateType;
  endTime?: string;
  showYear?: boolean;
}

export const EventDate: FunctionalComponent<Props> = ({ date, endTime, showYear }) => {
  const { shortDay, weekday, day, year, time } = date
  return (
    <div>
      <div>{weekday}</div>
      <div>
        {showYear ? shortDay : day}
        {showYear ? `, ${year}` : undefined}
      </div>
      <div>
        {time}
        {endTime && ` — ${endTime}`}
      </div>
    </div>
  );
}
